import React, { Dispatch, SetStateAction, useEffect, /* useState */ } from 'react';
import { TooltipInfoIcon } from '@icons';
import { useQuery } from '@tanstack/react-query';
import { ProjectType } from '@lib/api_ts/projectApi';
import { Col, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import Select from 'react-select';
import { translate } from 'components/translation/translation';
import { getSamplingRules } from '@lib/api';

interface AdvancedSetupFormProps {
    activeKey: string;
    projectToSave: Partial<ProjectType> | undefined;
    setProjectToSave: Dispatch<SetStateAction<ProjectType | undefined>>;
    isDirty: boolean;
    setIsDirty: Dispatch<SetStateAction<boolean>>;
    selectedSamplingRule: { value: number; label: string }[];
    setSelectedSamplingRule: Dispatch<SetStateAction<{ value: number; label: string }[]>>;
}

const AdvancedSetupForm: React.FC<AdvancedSetupFormProps> = (
    { activeKey, projectToSave, setProjectToSave, isDirty, setIsDirty, selectedSamplingRule, setSelectedSamplingRule }
) => {

    const { data: optionsSamplingRules } = useQuery({
        queryKey: ['optionsSamplingRules', projectToSave.id],
        queryFn: async () => {
            const result = await getSamplingRules();

            if (!result.success) {
                throw new Error('Failed to fetch sampling history');
            }

            let tempOptionsSamplingRules = result.data.map((samplingRule: { id: any; name: any; }) => ({
                value: samplingRule.id,
                label: samplingRule.name,
            }));

            return tempOptionsSamplingRules;
        },
        enabled: !!projectToSave.id,
    });

    useEffect(() => {
        if (projectToSave && projectToSave.notice && optionsSamplingRules) {
            const savedSamplingRule = projectToSave.samplingRuleAssignment ?? projectToSave.notice.samplingRuleAssignment ?? null;
            const samplingRuleId = savedSamplingRule?.samplingRuleId;

            setSelectedSamplingRule(samplingRuleId !== undefined ? optionsSamplingRules.filter((option) => option.value === samplingRuleId) : []);
        }

    }, [optionsSamplingRules, projectToSave, setSelectedSamplingRule]);

    return <Form
        //   onSubmit={handleSaveProject}
        id="form-new-project">
        {activeKey === 'advancedSettings' &&
            projectToSave?.advancedConfig?.length > 0 &&
            projectToSave?.advancedConfig
                .sort((a, b) => a.id - b.id)
                .map((el, i) => {
                    return projectToSave.streamConfigurationType === 'WP' && el.name === 'disable_tenders' ? null : (
                        <Row key={el.name} className="mb-3">
                            <Form.Group as={Col}>
                                <Form.Check
                                    inline
                                    type="checkbox"
                                    name={el.name}
                                    defaultChecked={projectToSave?.advancedConfig?.some(
                                        (advConfig) => Number(advConfig.id) === Number(el.id) && advConfig.enabled,
                                    )}
                                    onClick={
                                        (event) => {
                                            if (!isDirty) setIsDirty(true);
                                            const isChecked = event.currentTarget.checked;
                                            setProjectToSave((prevProjectToSave) => ({
                                                ...prevProjectToSave,
                                                advancedConfig: prevProjectToSave?.advancedConfig?.map((config) =>
                                                    config.id === el.id ? { ...config, enabled: isChecked } : config
                                                ) || [],
                                            }));
                                        }                                                              // (e) => onAdvancedChange(e, 'advancedSettings', setThisProject, el.id)
                                    }
                                />
                                <Form.Label>{el.label}</Form.Label>
                                {el.description && (
                                    <OverlayTrigger
                                        placement="top"
                                        delay={{ show: 200, hide: 400 }}
                                        overlay={<Tooltip id="button-tooltip">{el.description}</Tooltip>}
                                    >
                                        <TooltipInfoIcon className="tooltip-ico" style={{ width: '1rem' }} />
                                    </OverlayTrigger>
                                )}
                            </Form.Group>
                            {el.name === 'sampling_activity' && (
                                <Form.Group as={Col} className="text-right">
                                    <Select
                                        components={{
                                            IndicatorSeparator: () => null,
                                        }}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        name="assignedRule"
                                        placeholder={translate('common.placeholder.selectsamplingrule', 'Seleziona regola di campionamento...')}
                                        value={selectedSamplingRule}
                                        options={optionsSamplingRules}
                                        onChange={(e) => { if (!isDirty) setIsDirty(true); setSelectedSamplingRule([e]) }}
                                        isDisabled={
                                            projectToSave?.samples?.length > 0 ||
                                            !projectToSave?.advancedConfig?.some((advConfig) => Number(advConfig.id) === Number(el.id) && advConfig.enabled)
                                        }
                                    />
                                </Form.Group>
                            )}
                        </Row>
                    );
                })}
    </Form>
}

export default AdvancedSetupForm